import React, {ReactNode} from 'react'
import {Modal} from '../../../components/library/modal/modal'

export const BigModal = ({
  title,
  children,
  onClose,
  order
}: {
  title: ReactNode
  children: ReactNode
  onClose: () => void
  order?: 'up' | 'down'
}) => {
  return (
    <Modal
      title={title}
      isOpen={true}
      handleClose={onClose}
      order={order}
      stopPropagation={true}
      // As this modal can be a child modal when operating from the add step UI
      style={{width: '97vw', height: '97vh'}}
    >
      {children}
    </Modal>
  )
}
